import React from 'react';
import { isEmail } from '../../helpers/validators';
import Text from '../Text';
import Toast from '../Toast';
import StateHeading from './StateHeading';
import UpgradeProgress from './UpgradeProgress';
import UpgradeIcon from './icons/UpgradeIcon';
import { ProgressData } from './types';
import { noticeClasses } from './styles';

export default function Upgrading({
  title,
  email,
  ...progress
}: ProgressData & { title: string; email: string }) {
  return (
    <>
      <StateHeading title={title}>
        Your data is moving to the new model. We'll recalculate cost basis as soon as the transfer finishes.
      </StateHeading>
      <UpgradeProgress key={`${progress.jobId ?? 'starting'}:${progress.currentStep}`} {...progress} />
      <Toast type="info" margin="" className={noticeClasses}>
        <div className="flex items-center gap-2 text-muted">
          <UpgradeIcon name="info" />
          <Text as="p" variant="muted" className="leading-6">
            {isEmail(email) ? "You can close this, we'll email you when it's done." : 'You can close this.'}
          </Text>
        </div>
      </Toast>
    </>
  );
}
